module.exports = __webpack_public_path__ + "static/Snow-c65012082dd28b5a254112e77e895c05.jpg";